import { render, staticRenderFns } from "./help-chat-list.vue?vue&type=template&id=06c83f89&scoped=true"
import script from "./help-chat-list.vue?vue&type=script&lang=js"
export * from "./help-chat-list.vue?vue&type=script&lang=js"
import style0 from "./help-chat-list.vue?vue&type=style&index=0&id=06c83f89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06c83f89",
  null
  
)

export default component.exports